import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  root: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 26px 14px",
    flexShrink: 0,
    backgroundColor: projectIqTokens.card,
    borderBottom: `1px solid ${projectIqTokens.line}`,
  },

  textBlock: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
    minWidth: 0,
  },

  action: {
    display: "flex",
    alignItems: "center",
    gap: designTokens.spacing[2],
    flexShrink: 0,
    marginLeft: designTokens.spacing[4],
  },

  engagementName: {
    fontSize: "12px",
    fontWeight: designTokens.fontWeight.semibold,
    color: projectIqTokens.faint,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  title: {
    margin: 0,
    fontSize: designTokens.fontSize.base,
    fontWeight: 800,
    color: projectIqTokens.ink,
    letterSpacing: "-0.01em",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});
